import React from "react";

interface HorizontalProps {
    marginTop?: number,
    marginBottom?: number,
    width?: number
}

const HorizontalSeparator: React.FC<HorizontalProps> = ({marginTop = 5, marginBottom = 25, width= 42}) => {
    return(
        <div style={{marginTop: marginTop, marginBottom: marginBottom}}>
            <div style={{flex: 1}} />
            <div style={{flex: 0, borderTop: `4px solid`, marginTop: 5, width: width}}/>
            <div style={{flex: 1}} />
        </div>
    )
};


export {
    HorizontalSeparator
}
